<template>
  <div class="container-fluid px-0">
    <LoginView :deal-id="dealId" v-if="!$store.getters.isAuthenticated"/>
    <div v-else class="home">

    <HeaderComponent />

      <DashboardView :deal-id="dealId"/>
    </div>
  </div>
</template>

<script>

import DashboardView from '@/views/DashboardView'
import LoginView from '@/components/LoginComponent'
import HeaderComponent from '@/components/HeaderComponent'

export default {
  name: 'HomeView',
  components: {
    LoginView,
    DashboardView,
    HeaderComponent
  },
  data () {
    return {
      dealId: ''
    }
  },
  beforeMount () {
    this.dealId = this.$route.params.id
  }
}
</script>

<style scoped>

</style>
